<template>
    <div class="homepage-reviews">
        <div class="rev-content">
            <div class="main-title">
                <h2 class="title">精选游记</h2>
                <h3 class="subtitle">爱上游轮，爱上皇家加勒比</h3>
            </div>
            <ul class="rev-list">
                <li  v-for="(item, i) in reviews" :key="('review_'+i)" @click="goReview(item.id)">
                    <div class="review-content" >
                        <img class="rev-pic" :src="item.image"
                            alt="">
                        <div class="rev-detail">
                            <div class="rev-title">{{item.title}}</div>
                            <div class="rev-shiptime">{{item.shipName}} &nbsp;&nbsp;|&nbsp;&nbsp; {{item.sailDate}}</div>
                            <div class="rev-shipname">{{item.route}}</div>
                            <div class="rev-pernum">
                                <span class="en-name">
                                    <img src="https://resource.rcclchina.com.cn/homePage/tag.png" alt="Alternate Text">
                                    {{item.author}}
                                </span>
                                <span class="en-num review-score-content "  @click="onUpvoteClick($event, item)">
                                    <img v-if="item.isUpvoted" class="zan-img score-image" src="https://resource.rcclchina.com.cn/Review/upvote/upvoted-1.png"/>
                                    <img v-else  class="zan-img score-image" src="https://resource.rcclchina.com.cn/Review/upvote/noupvote.png"/>
                                    <span class="review-score">{{item.score.toFixed(0)}}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <a class="link-btn" href="/Rccl.Review/Travel/tn-n-n-0-0-9.html" target="_blank">更多精选游记&nbsp;&nbsp;&gt;</a>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: 'HomeReview',
    props: {
        reviewArticles: {
            type: Array,
            default () {
                return []
            }
        }
    },
    computed: {
      userToken() {
        return this.$store.state.user.userToken;
      }
    },
    data () {
        return {
            reviews: [],
            token: ""
        }
    },
    beforeMount () {
        this.reviews = this.reviewArticles
        this.getUpvote()
    },
    methods: {
        getUpvoteByReview(reviewId) {
            return this.upvoteData.find(r=>r.id == reviewId) || {}
        },
        async onUpvoteClick (e, review) {
            e.stopPropagation()
            if (!this.userToken) {
              this.$alert.show('请先登录')
              return
            }
            if (review.isUpvoted) {
                this.$alert.show("您已点过赞了")
            } else {
                this.$loading.show()
                const { success , errMsg } = await api.review.upvote({
                    articalId: review.id
                })
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
                review.score++
                review.isUpvoted = true

            }
        },
        async getUpvote () {
            const reviewIds = this.reviewArticles.map(r=>r.id)
            if (reviewIds.length == 0) return
            const { success, data } = await api.review.getUpvote({
                reviewIds
            })
            if (!success) {
                return
            }
            this.reviews.forEach((review) => {
                const upvoteReview = data.find(r=>r.id == review.id)
                if (upvoteReview) {
                    review.score = upvoteReview.score
                    review.isUpvoted = upvoteReview.isUpvoted
                }
            })
        },
        goReview (reviewId) {
            window.open(`/Rccl.Review/Travel/d-n-n-0-0-${reviewId}.html`)
        }
    },
    watch: {
        reviewArticles(newValue) {
            this.reviews = newValue
            this.getUpvote()
        } 
    }
}
</script>
